import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { injectIntl } from 'react-intl'
import { createStructuredSelector } from 'reselect'

import { countryCodeSelector } from '@/checkout-instore-legacy/order/selectors'
import { availableAddressesSelector } from '@/checkout-instore-legacy/shipping/selectors'
import {
  getCustomerNameSelector,
  isCustomerAnonymousNameSelector,
} from '@/checkout-instore-legacy/customer/selectors'
import LocationModal from '../components/CartLocation/LocationModal'
import { setPostalCodeSession } from '@/checkout-instore-legacy/session/actions'

const mapStateToPropsSelector = createStructuredSelector({
  availableAddresses: availableAddressesSelector,
  receiverName: getCustomerNameSelector,
  isAnonymousName: isCustomerAnonymousNameSelector,
  countryCode: countryCodeSelector,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setPostalCodeSession }, dispatch)

export default injectIntl(
  connect(mapStateToPropsSelector, mapDispatchToProps)(LocationModal)
)
